import { Topnav } from './Topnav'
import { Banner } from './Banner'
import { Footer } from './Footer'
import { HomepageContent } from './HomepageContent'
import React from 'react'

const Homepage = () => {
  return (
    <div className="homepage-main">
      <div className="container">
        <Topnav />
        <Banner />
        <HomepageContent />
      </div>
      <Footer />
    </div>
  )
}

export default Homepage
